import React, { useState, useRef, useEffect } from "react";
import { Col, Row, Form, Button, Card } from "react-bootstrap";
import { useFormik } from "formik";
import Select from "react-select";
import FeatherIcon from "feather-icons-react";
import { convertUtcToLocal } from "../../../utils/functions";
import { useSelector } from "react-redux";
import { IReduxState } from "../../../utils/types";
import { updateCampaign } from "../../../Redux/Actions/CampaignsActions";
import {
  counties_list,
  os_list,
  browsers_list,
} from "../../Admin/AdminConstant";
import * as yup from "yup";

interface EditCampaignProps {
  modalData: any;
  dispatch: any;
  cfscId_list: any;
  isDisplayCjscIdDropdown: boolean;
  disableCJSCIDSelection: any;
  countries: any;
  countries_type: any;
  oss: any;
  oss_type: any;
  browsers: any;
  browsers_type: any;
  loggedInUser: any;
  onClose: () => void;
  isAdmin?: boolean;
}

const EditCampaign = ({
  modalData,
  dispatch,
  cfscId_list,
  isDisplayCjscIdDropdown,
  disableCJSCIDSelection,
  countries,
  countries_type,
  oss,
  oss_type,
  browsers,
  browsers_type,
  loggedInUser,
  isAdmin,
  onClose,
}: EditCampaignProps) => {
  const AuthState = useSelector((state: IReduxState) => state.Auth);
  const [showInput, setShowInput] = useState(false);
  const domainUploadRef = useRef<HTMLInputElement>(null);
  const appUploadRef = useRef<HTMLInputElement>(null);
    const [domains_CSV, setDomains_CSV] = useState<any>('');
  const [apps_CSV, setApps_CSV] = useState<any>('');

  const regex = AuthState.truncated_ips
    ? /^(((((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)?)|([0-9a-fA-F]{1,4}:){2}([0-9a-fA-F]{1,4}:?){1}(:[0-9a-fA-F]{1,4}){0,3}(:[0-9a-fA-F]{1,4})?))\n)*(((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)?)|([0-9a-fA-F]{1,4}:){2}([0-9a-fA-F]{1,4}:?){1}(:[0-9a-fA-F]{1,4}){0,3}(:[0-9a-fA-F]{1,4})?)$/
    : /^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}))(\s*[\r\n]+(?:(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4})))*$/i;
  const multiRegex =
    /^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}))(\s*[\r\n|-]+(?:(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4})))*$/i;
  const valText = AuthState.truncated_ips
    ? "Please use a valid IPv4 or IPv6 address"
    : "Please use full IPv4 or IPv6 address format";
  const urlRegex =
    /^(https?:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[^\/\s]+)+(?:\/[^\s]*)?)(\nhttps?:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[^\/\s]+)+(?:\/[^\s]*)?)*$/;
  const ipv4Regex =
    /^(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})/;
  const ipv4Text = "Please use a valid IPv4 address";

  const formik = useFormik({
    initialValues: {
      // ...modalData, // Use all modalData fields as initial values
      id: modalData?.id || "",
      cjscName: modalData?.cjscName || "",
      ids: modalData?.userID?.replace(/,/g, "\n") || "",
      ips:
        modalData?.type === "Header" || modalData?.type == "iPnoId"
          ? modalData?.IP?.replace(/,/g, "\n") || ""
          : "",
      adUrl: modalData?.adUrl || "",
      urlType: modalData?.manualScript
        ? "script"
        : modalData?.fakeUrl
        ? "testUrl"
        : modalData?.ua
        ? "urlUserAgent"
        : "adUrl",
      // script: modalData?.script || "",
      // maxFifo: modalData?.repeat || 1, //////
      origin:modalData?.origin||"",
      always: modalData?.always ?? true,
      startDate: modalData?.startDate || "",
      startHour: modalData?.startHour || "",
      endDate: modalData?.endDate || "",
      endHour: modalData?.endHour || "",
      type: modalData?.type || "",
      manual_script: "",
      userAgent: modalData?.ua || "",
      cjsc_countries: modalData?.cjsc_countries || [],
      cjsc_browsers: modalData?.cjsc_browsers || [],
      cjsc_os: modalData?.cjsc_os || [],
      domainType: modalData?.domainType || "off",
      bundleType: modalData?.bundleType || "off",
      domains: modalData?.domains || [],
      bundles: modalData?.bundles || [],
      countries_whitelist_blacklist:
        modalData?.countries_whitelist_blacklist || "wl",
      browsers_whitelist_blacklist:
        modalData?.browsers_whitelist_blacklist || "wl",
      oss_whitelist_blacklist: modalData?.oss_whitelist_blacklist || "wl",
      v2_time: modalData?.v2_time,
      v2_ip: modalData?.v2_ip,
      v2_ua: modalData?.v2_ua,
      cjsc_ignoreHttp: modalData?.ignoreHttp || false,
        },
        validationSchema: yup.object().shape({
      cjscName: yup
        .string()
        .matches(
          /^[a-z\d_]+$/i,
          "Please use only letters,numbers and underscore"
        )
        .required("*"),
      v2_ip: yup.string().matches(ipv4Regex, ipv4Text),
      ids: yup
        .string()
        .when("type", {
          is: (value: string) => value === "Query" || value === "Both",
          then: yup
        .string()
        .matches(/^(\S+\n)*\S+$/, "Spaces are not allowed")
        .required("*"),
        })
        .when("type", {
          is: (value: string) => value === "Header" || value === "iPnoId",
          then: yup.string().matches(regex, valText).required("*"),
        })
        .when(["isIDIP", "notCjscMultiCampaign"], {
          is: true,
          then: yup
            .string()
            .matches(
              // /^(\S+$\n)/g,
              /^(\S+\n)*\S+$/,
              "Spaces are not allowed"
            )
            .required("*"),
        })
        .when(["isMultiIPID"], {
          is: true,
          then: yup.string().matches(multiRegex, valText).required("*"),
        })
        .when(["isMultiIPnoID"], {
          is: true,
          then: yup.string().matches(multiRegex, valText).required("*"),
        }),
      ips: yup.string().when("type", {
        is: (value: string) => value === "Both",
        then: yup.string().matches(regex, valText).required("*"),
      }).when("type", {
                      is: (value: string) => value === "Query",
                      then: yup.string().matches(
                          regex,
                          valText
                  )}),
      adUrl: yup
        .string()
        .matches(
          urlRegex,
          "Please insert the link in correct format."
        )
        .when("showAdUrl", {
          is: true,
          then: yup.string().required("*"),
        }),

      startDate: yup.string().when("always", {
        is: false,
        then: yup.string().required("*"),
      }),
      startHour: yup.string().when("always", {
        is: false,
        then: yup.string().required("*"),
      }),
      endDate: yup.string().when("always", {
        is: false,
        then: yup.string().required("*"),
      }),
      endHour: yup.string().when("always", {
        is: false,
        then: yup.string().required("*"),
      }),
      type: yup.string().required("*"),
      manual_script: yup.string().when(["fakeUrl", "test_oren"], {
        is: false,
        then: yup.string().required("*"),
      }),
      // user_ids_wbl_list: yup
      //   .string()
      //   .test(
      //     "no-spaces-in-lines",
      //     "Spaces are not allowed in any user ID",
      //     (value) => {
      //       if (!value) return true;
      //       return value.split("\n").every((line) => !/\s/.test(line));
      //     }
      //   ),
    }),
    onSubmit: async (values) => {
      // Dispatch updateCampaign with the new values
      // console.log("Submitting campaign update with values:", values);
      console.log("Submitting campaign update with values:", values);
      await dispatch(updateCampaign({ ...values }));
      onClose();
    },
  });

  const isScript = formik.values.urlType === "script";
  const isAdUrl = formik.values.urlType === "adUrl";

  const URL_TYPE_OPTIONS = [
    { value: "adUrl", label: "Ad URL", show: true },
    { value: "testUrl", label: "Test URL", show: true },
    { value: "script", label: "Script", show: AuthState.cjsc_script },
    { value: "panda", label: "De-anon", show: AuthState.panda },
    {
      value: "urlUserAgent",
      label: "User Agent",
      show: AuthState.cjsc_user_agent,
    },
    { value: "monitor", label: "Monitor", show: AuthState.monitor },
  ];

  const onCJSCIDChange = (e: any) => {
    let index = cfscId_list.findIndex((el: any) => {
      return el.value === e.value;
    });
    formik.setFieldValue("cjscId", cfscId_list[index]);
  };

  let ipAddresses = modalData.IP?.split(",");

  let modifiedIPs = ipAddresses?.map((ip: any) => {
    let newIP = ip.trim();

    if ((newIP.match(/:/g) || []).length >= 2) {
      if (!newIP.endsWith(":")) {
        newIP += ":X";
      } else {
        newIP += "X";
      }
    }
    //((IP.match(/\./g) || []).length == 2 ? (!IP.endsWith('.') ? IP += '.X' : IP += 'X') : (IP.match(/\./g) || []).length == 3 ? (!IP.endsWith('.') ? IP : IP += 'X') : IP)
    else if ((newIP.match(/\./g) || []).length === 2) {
      if (!newIP.endsWith(".")) {
        newIP += ".X";
      } else {
        newIP += "X";
      }
    } else if ((newIP.match(/\./g) || []).length === 3) {
      if (newIP.endsWith(".")) {
        newIP += "X";
      }
    }
    return newIP;
  });

  // console.log("modalData:  ",modalData);
  const generateOptions = (
    modalDataList: string[],
    authStateList: string[],
    referenceList: { code: string; name: string }[],
    authStateType: string
  ) => {
    let options;

    if (authStateType === "bl") {
      // Exclude the selected countries from the reference list
      options = referenceList
        .filter((item: any) => !authStateList.includes(item.code))
        .map((item: any) => ({
          value: item.code,
          label: item.name,
        }));
    } else {
      options = authStateList.map((code: string) => {
        const obj = referenceList.find((item: any) => item.code === code);
        return obj
          ? { value: obj.code, label: obj.name }
          : { value: code, label: code };
      });
    }

    const commonOptions = (modalDataList || [])
      .filter((item: string) => authStateList.includes(item))
      .map((code: string) => {
        const obj = referenceList.find((item: any) => item.code === code);
        return obj
          ? { value: obj.code, label: obj.name }
          : { value: code, label: code };
      });

    return { options, commonOptions };
  };

  const { options: countriesOptions, commonOptions: commonCountries } =
    generateOptions(
      modalData.cjsc_countries,
      AuthState.countries,
      counties_list,
      AuthState.countries_type
    );

  const { options: ossOptions, commonOptions: commonOSS } = generateOptions(
    modalData.cjsc_oss,
    AuthState.oss,
    os_list,
    AuthState.oss_type
  );

  const { options: browsersOptions, commonOptions: commonBrowsers } =
    generateOptions(
      modalData.cjsc_browsers,
      AuthState.browsers,
      browsers_list,
      AuthState.browsers_type
    );

    const handleDomainUpload = () => {
        if (domainUploadRef) {
            domainUploadRef?.current?.click();
        }
    }

    const handleAppUpload = () => {
        if (appUploadRef) {
            appUploadRef?.current?.click();
        }
    }

  const handleCSVUpload = (event: any, fieldtype: string) => {
    const fileInput = event.target;
    const fileObj = fileInput.files && fileInput.files[0];
    
    if (!fileObj) {
      return;
    }

    if (fileObj && fileObj.name.endsWith('.csv')) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const content = e.target.result;
        const rows = content.split('\n').map((row: string) => row.trim()).filter(Boolean);
        
        if (fieldtype === 'domains') {
          setDomains_CSV(fileObj);
          formik.setFieldValue('domains', rows);
        }
        if (fieldtype === 'apps') {
          setApps_CSV(fileObj);
          formik.setFieldValue('bundles', rows);
        }
        fileInput.value = '';
      };
      reader.readAsText(fileObj);
    } else {
      alert('Please select a valid CSV file.');
      fileInput.value = '';
    }
  };

  const downloadCSVFile = (csvType: string) => {
    let csvContent: string;
    let fileName: string;
    
    if (csvType === 'domains') {
      csvContent = "example.com\ndomain.com\nsubdomain.domain.com";
      fileName = 'Domains_Example';
    } else {
      csvContent = "com.example.app\ncom.domain.app\ncom.subdomain.app";
      fileName = 'Apps_Example';
    }

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="popUp">
        <Row className="d-flex justify-content-center mt-3">
          <Row>
            <h3 className="module_title">Edit Campaign</h3>
          </Row>
        </Row>
        <div className="form">
          <Row>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label
                  column
                  lg={3}
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                >
                  Campaign ID{" "}
                </Form.Label>
                <Col lg={9}>
                  <Select
                    className="react-select react-select-container fsz-875rem"
                    classNamePrefix="react-select"
                    onChange={onCJSCIDChange}
                    defaultValue={
                      cfscId_list.find(
                        (el: any) => el.value === modalData.origin
                      ) || null
                    }
                    name="cjscId"
                    options={cfscId_list}
                    hideSelectedOptions={false}
                    // value={formik.values?.cjscId}
                    isDisabled={disableCJSCIDSelection}
                  />
                </Col>
              </Form.Group>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={3}>
                  Name
                  {typeof formik.errors?.cjscName === "string" &&
                    formik.errors.cjscName.includes("*") && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    )}
                </Form.Label>
                <Col lg={9}>
                  <Form.Control
                    name="name"
                    type="text"
                    value={formik.values.cjscName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={!!formik.errors.cjscName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {typeof formik.errors?.cjscName === "string" &&
                    !(
                      formik.errors.cjscName.includes("*") ||
                      formik.errors.cjscName.includes("required")
                    )
                      ? formik.errors.cjscName
                      : ""}
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={3}>
                  {modalData.type == "Query" || modalData.type == "Both"
                    ? "User IDs"
                    : "IP Addresses"}
                  {typeof formik.errors?.ids === "string" &&
                    !(
                      formik.errors?.ids && formik.errors.ids?.includes("*")
                    ) && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    )}{" "}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: "14px !important",
                      opacity: "0.5",
                    }}
                  >
                    Separated by rows
                  </p>
                </Form.Label>
                <Col lg={9}>
                  <Form.Control
                    name="ids"
                    as="textarea"
                    rows={2}
                    defaultValue={formik.values.ids}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={!!formik.errors.ids || !!formik.errors.ips}
                  />
                </Col>
                <Form.Control.Feedback type="invalid">
                  {typeof formik.errors?.ids === "string" &&
                  !(
                    formik.errors.ids.includes("*") ||
                    formik.errors.ids.includes("required")
                  )
                    ? formik.errors.ids
                    : ""}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={3} id="smallerFontSize">
                  URL Type
                </Form.Label>
                <Col lg={9}>
                  <Form.Select
                    className="fsz-875rem"
                    name="type"
                    defaultValue={
                      URL_TYPE_OPTIONS.find((opt) => {
                        if (modalData.fakeUrl && opt.value === "testUrl")
                          return true;
                        if (modalData.panda && opt.value === "panda")
                          return true;
                        if (modalData.manualScript && opt.value === "script")
                          return true;
                        if (
                          modalData.urlUserAgent === true &&
                          opt.value === "urlUserAgent"
                        )
                          return true;
                        if (modalData.monitor && opt.value === "monitor")
                          return true;
                        if (
                          !modalData.fakeUrl &&
                          !modalData.panda &&
                          !modalData.manualScript &&
                          !modalData.urlUserAgent &&
                          !modalData.monitor &&
                          opt.value === "adUrl"
                        )
                          return true;
                        return false;
                      })?.value || "adUrl"
                    }
                    disabled={
                      formik.values.type === "Multi Ad URL With User ID" ||
                      formik.values.type === "Multi Ad URL Without User ID"
                    }
                    onChange={async (e) => {
                      formik.setFieldValue("urlType", e.target.value);
                      formik.validateForm();
                      formik.setFieldValue("adUrl", "");
                    }}
                  >
                    {URL_TYPE_OPTIONS.filter((opt) => opt.show).map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>
              {(formik.values.urlType == "adUrl") && (
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label column lg={3} id="smallerFontSize">
                      AD URL
                    </Form.Label>
                    <Col lg={9}>
                      {!showInput ? (
                        <Button
                          variant="primary"
                          onClick={() => setShowInput(true)}
                          // style={{ width: "150px" }}
                        >
                          Edit AD URL
                        </Button>
                      ) : (
                        <>
                          <Form.Control
                            type="text"
                            name="adUrl"
                            placeholder="Enter AD URL"
                            className="fsz-875rem"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.errors.adUrl}
                          />
                          <Form.Control.Feedback type="invalid">
                            {typeof formik.errors.adUrl === "string" &&
                              formik.errors.adUrl}
                          </Form.Control.Feedback>
                        </>
                      )}
                    </Col>
                  </Form.Group>
                )}
                {(formik.values.urlType === "script") && (
                  <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                        <Form.Label column lg={3} id="smallerFontSize">Script {formik.errors?.manual_script?.includes('*') && <span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }}>{formik.errors.manual_script}</span>}</Form.Label>
                                        <Col lg={9}>
                                            <Form.Control type="text" id="cjsc-script" name="manual_script"
                                                onChange={formik.handleChange} onBlur={formik.handleBlur} className="fsz-875rem" as="textarea" rows={5} isInvalid={!!formik.errors.manual_script} />
                                            <Form.Control.Feedback type="invalid"> {formik.errors?.manual_script?.includes('*') || formik.errors?.manual_script?.includes('required') ? '' : formik.errors.manual_script} </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>

                )}
            </Col>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={3}>
                  Type
                </Form.Label>
                <Col lg={9}>
                  <Form.Control
                    name="type"
                    type="text"
                    value={
                      modalData.type === "Query"
                        ? "User ID"
                        : modalData.type === "Header"
                        ? "IP Address"
                        : modalData.type === "Both"
                        ? "User ID + IP Address"
                        : modalData.type === "ipNoId"
                        ? "IP Without User ID"
                        : modalData.type === "multiad_ipid"
                        ? "Multi Ad URL With User ID"
                        : modalData.type === "multiad_ipnoid"
                        ? "Multi Ad URL Without User ID"
                        : modalData.type === "FIFO"
                        ? "FIFO"
                        : "Infinite FIFO"
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled
                  />
                </Col>
              </Form.Group>
              {/* {(modalData.type === "Header" || modalData.type === "iPnoId") && ( */}
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={3} id="smallerFontSize">
                  User Agent
                </Form.Label>
                <Col lg={9}>
                  <Form.Control
                    id="user-agent"
                    type="text"
                    name="userAgent"
                    defaultValue={modalData.ua}
                    className="fsz-875rem"
                    onChange={formik.handleChange}
                  />
                </Col>
              </Form.Group>
              {(modalData.type == "Query" || modalData.type == "Both") && (
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={3}
                    htmlFor="example-email"
                    id="smallerFontSize"
                    style={{ alignSelf: "flex-start" }}
                  >
                    {"IP Addresses"}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Control
                      id="example-email"
                      name="ips"
                      as="textarea"
                      rows={2}
                      defaultValue={(modifiedIPs.length > 0
                        ? modifiedIPs.join("\n")
                        : modalData.IP
                      ).replace(/,/gi, "\n")}
                      onChange={formik.handleChange}
                      isInvalid={!!formik.errors.ips}
                    />
                    <Form.Control.Feedback type="invalid">
                      {typeof formik.errors?.ips === "string" &&
                      !(
                        formik.errors.ips.includes("*") ||
                        formik.errors.ips.includes("required")
                      )
                        ? formik.errors.ips
                        : ""}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
              )}
              {/* )} */}
            </Col>
          </Row>

            <Card className="mt-3">
            <Card.Body>
              <h4 className="mb-3 header-title mt-0">
              Whitelists and Blacklists
              </h4>
              <Row>
              <Col md={6}>
                <Form.Label column lg={3} id="smallerFontSize">
                Domains
                </Form.Label>
                <Form.Group
                as={Row}
                style={{ display: "flex", alignItems: "center" }}
                >
                <Col lg={9}>
                  <div className="checkboxes">
                  <Form.Check
                    type="radio"
                    name="domain_whitelist_blacklist"
                    value="off"
                    checked={
                    (modalData.domains &&
                      modalData.domains.length <= 0) ||
                    formik.values.domainType == "off"
                      ? true
                      : false
                    }
                    onChange={() =>
                    formik.setFieldValue("domainType", "off")
                    }
                  />{" "}
                  <Form.Label
                    style={{ marginLeft: "5px" }}
                    column
                    lg={4}
                    id="smallerFontSize"
                  >
                    {" "}
                    Off{" "}
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    name="domain_whitelist_blacklist"
                    value="whitelist"
                    checked={formik.values.domainType === "wl"}
                    style={{ marginLeft: "5px" }}
                    onChange={() =>
                    formik.setFieldValue("domainType", "wl")
                    }
                  />{" "}
                  <Form.Label
                    style={{ marginLeft: "5px" }}
                    column
                    lg={4}
                    id="smallerFontSize"
                  >
                    {" "}
                    Whitelist{" "}
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    name="domain_whitelist_blacklist"
                    value="blacklist"
                    checked={formik.values.domainType === "bl"}
                    style={{ marginLeft: "5px" }}
                    onChange={() =>
                    formik.setFieldValue("domainType", "bl")
                    }
                  />{" "}
                  <Form.Label
                    style={{ marginLeft: "5px" }}
                    column
                    lg={4}
                    id="smallerFontSize"
                  >
                    {" "}
                    Blacklist{" "}
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    name="domain_whitelist_blacklist"
                    value="block"
                    checked={formik.values.domainType === "blk"}
                    style={{ marginLeft: "5px" }}
                    onChange={() =>
                    formik.setFieldValue("domainType", "blk")
                    }
                  />{" "}
                  <Form.Label
                    style={{ marginLeft: "5px" }}
                    column
                    lg={6}
                    id="smallerFontSize"
                  >
                    {" "}
                    Block All Domains{" "}
                  </Form.Label>
                  </div>
                </Col>
                 <Col lg={9} style={{ marginTop: '15px' }}>
                                        <input
                                            ref={domainUploadRef}
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept=".csv"
                                            onChange={(e) => handleCSVUpload(e, 'domains')}
                                        />
                                        <Row>
                                            <Col lg={12}>
                                                <div className="d-flex flex-wrap gap-2">
                                                    <Button className="m-0" variant="primary" disabled={(formik?.values?.domainType === 'off' || formik?.values?.domainType === 'block') ? true : false} onClick={() => handleDomainUpload()}>Upload New CSV</Button>
                                                    <span
                                                        style={
                                                            {
                                                                textDecoration: "none",
                                                                color: '#0077b6',
                                                                fontWeight: 'bold',
                                                                margin: '5px',
                                                                cursor: 'pointer'
                                                            }
                                                        }
                                                        onClick={() => downloadCSVFile('domain')}>Download CSV Example</span>
                                                </div>
                                            </Col>
                                            {domains_CSV?.name && <Col lg={12} className="mt-2"><span>{domains_CSV?.name}</span></Col>}
                                        </Row>
                                    </Col>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Label column lg={3} id="smallerFontSize">
                Apps
                </Form.Label>
                <Form.Group
                as={Row}
                style={{ display: "flex", alignItems: "center" }}
                >
                <Col lg={9}>
                  <div className="checkboxes">
                  <Form.Check
                    type="radio"
                    name="app_whitelist_blacklist"
                    value="off"
                    checked={
                    (modalData.bundles &&
                      modalData.bundles.length <= 0) ||
                    formik.values.bundleType == "off"
                      ? true
                      : false
                    }
                    onChange={() =>
                    formik.setFieldValue("bundleType", "off")
                    }
                  />{" "}
                  <Form.Label
                    style={{ marginLeft: "5px" }}
                    column
                    lg={4}
                    id="smallerFontSize"
                  >
                    {" "}
                    Off{" "}
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    name="app_whitelist_blacklist"
                    value="whitelist"
                    checked={formik.values.bundleType === "wl"}
                    style={{ marginLeft: "5px" }}
                    onChange={() =>
                    formik.setFieldValue("bundleType", "wl")
                    }
                  />{" "}
                  <Form.Label
                    style={{ marginLeft: "5px" }}
                    column
                    lg={4}
                    id="smallerFontSize"
                  >
                    {" "}
                    Whitelist{" "}
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    name="app_whitelist_blacklist"
                    value="blacklist"
                    checked={formik.values.bundleType === "bl"}
                    style={{ marginLeft: "5px" }}
                    onChange={() =>
                    formik.setFieldValue("bundleType", "bl")
                    }
                  />{" "}
                  <Form.Label
                    style={{ marginLeft: "5px" }}
                    column
                    lg={4}
                    id="smallerFontSize"
                  >
                    {" "}
                    Blacklist{" "}
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    name="app_whitelist_blacklist"
                    value="block"
                    checked={formik.values.bundleType === "blk"}
                    style={{ marginLeft: "5px" }}
                    onChange={() =>
                    formik.setFieldValue("bundleType", "blk")
                    }
                  />{" "}
                  <Form.Label
                    style={{ marginLeft: "5px" }}
                    column
                    lg={5}
                    id="smallerFontSize"
                  >
                    {" "}
                    Block All Apps{" "}
                  </Form.Label>
                  </div>
                </Col>
<Col lg={9} style={{ marginTop: '15px' }}>
    <input
        ref={appUploadRef}
        style={{ display: 'none' }}
        type="file"
        accept=".csv"
        onChange={(e) => handleCSVUpload(e, 'apps')}
    />
    <Row>
        <Col lg={12}>
            <div className="d-flex flex-wrap gap-2">
                <Button 
                    className="m-0" 
                    variant="primary" 
                    disabled={(formik?.values?.bundleType === 'off' || formik?.values?.bundleType === 'block') ? true : false} 
                    onClick={() => handleAppUpload()}
                >
                    Upload New CSV
                </Button>
                <span
                    style={{
                        textDecoration: "none",
                        color: '#0077b6',
                        fontWeight: 'bold',
                        margin: '5px',
                        cursor: 'pointer'
                    }}
                    onClick={() => downloadCSVFile('apps')}
                >
                    Download CSV Example
                </span>
            </div>
        </Col>
        {apps_CSV?.name && <Col lg={12} className="mt-2"><span>{apps_CSV?.name}</span></Col>}
    </Row>
</Col>
                </Form.Group>
              </Col>
              </Row>
              <hr />
              { AuthState.show_cjsc_ignoreHttp && (
              <Row>
                                          <Col>
              
                                              <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                                  <Form.Label column lg={3} id="smallerFontSize">Ignore http</Form.Label>
                                                  <Col lg={4}>
                                                  <Form.Select className="fsz-875rem" name="type" placeholder="open this select menu" defaultValue={modalData.ignoreHttp ? 'true' : 'false'} 
                                                  onChange={formik.handleChange}>
                                                              <option value={'false'}>False</option>
                                                              <option value={'true'}>True</option>
                                                              
              
                                                          </Form.Select>
                                                  </Col>
                                              </Form.Group>
                                          </Col>
                                      </Row>
              )}
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mt-2"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label column lg={3} id="smallerFontSize">
                      Countries
                    </Form.Label>
                    <Col lg={4}>
                      <Select
                        isMulti
                        className="react-select react-select-container"
                        classNamePrefix="react-select"
                        options={countriesOptions}
                        defaultValue={commonCountries}
                        onChange={(selected) => {
                          formik.setFieldValue(
                            "cjsc_countries",
                            (selected as any[]).map((opt) => opt.value)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={5}>
                      <div className="checkboxes">
                        <Form.Check
                          type="radio"
                          name="countries_whitelist_blacklist"
                          checked={
                            formik.values.countries_whitelist_blacklist === "wl"
                          }
                          value="wl"
                          onChange={() =>
                            formik.setFieldValue(
                              "countries_whitelist_blacklist",
                              "wl"
                            )
                          }
                          style={{ marginLeft: "5px" }}
                          disabled={
                            countries_type === "wl" && countries.length > 0
                          }
                        />
                        <Form.Label
                          style={{ marginLeft: "5px" }}
                          column
                          lg={4}
                          id="smallerFontSize"
                        >
                          Whitelist
                        </Form.Label>
                        <Form.Check
                          type="radio"
                          name="countries_whitelist_blacklist"
                          checked={
                            formik.values.countries_whitelist_blacklist === "bl"
                          }
                          value="bl"
                          onChange={() =>
                            formik.setFieldValue(
                              "countries_whitelist_blacklist",
                              "bl"
                            )
                          }
                          style={{ marginLeft: "5px" }}
                          disabled={
                            countries_type === "wl" && countries.length > 0
                          }
                        />
                        <Form.Label
                          style={{ marginLeft: "5px" }}
                          column
                          lg={4}
                          id="smallerFontSize"
                        >
                          Blacklist
                        </Form.Label>
                      </div>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              {modalData.system_countries_bl.length > 0 && (
                <Row>
                  <Form.Group
                    as={Row}
                    className="mt-2"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Col lg={3}></Col>
                    <Col lg={4}>
                      <FeatherIcon icon="alert-circle" size={15} />
                      <b> System Blacklisted Countries : </b>
                      {(() => {
                        let cbl_str = "";
                        if (modalData?.system_countries_bl?.length > 0) {
                          const countriesFiltered = counties_list.filter(
                            (country: any) =>
                              modalData.system_countries_bl.includes(
                                country.code
                              )
                          );
                          countriesFiltered.forEach((el: any) => {
                            cbl_str += `${el.name} (${el.code}), `;
                          });
                          cbl_str = cbl_str.slice(0, -2);
                        }
                        return cbl_str;
                      })()}
                    </Col>
                  </Form.Group>
                </Row>
              )}
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mt-2"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label column lg={3} id="smallerFontSize">
                      Operating Systems
                    </Form.Label>
                    <Col lg={4}>
                      <Select
                        isMulti
                        className="react-select react-select-container"
                        classNamePrefix="react-select"
                        options={ossOptions}
                        defaultValue={commonOSS}
                        onChange={(selected) => {
                          formik.setFieldValue(
                            "cjsc_os",
                            (selected as any[]).map((opt) => opt.value)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={5}>
                      <div className="checkboxes">
                        <Form.Check
                          type="radio"
                          name="oss_whitelist_blacklist"
                          checked={
                            formik.values.oss_whitelist_blacklist === "wl"
                          }
                          value="wl"
                          onChange={() =>
                            formik.setFieldValue(
                              "oss_whitelist_blacklist",
                              "wl"
                            )
                          }
                          style={{ marginLeft: "5px" }}
                          disabled={oss_type === "wl" && oss.length > 0}
                        />
                        <Form.Label
                          style={{ marginLeft: "5px" }}
                          column
                          lg={4}
                          id="smallerFontSize"
                        >
                          Whitelist
                        </Form.Label>
                        <Form.Check
                          type="radio"
                          name="oss_whitelist_blacklist"
                          checked={
                            formik.values.oss_whitelist_blacklist === "bl"
                          }
                          value="bl"
                          onChange={() =>
                            formik.setFieldValue(
                              "oss_whitelist_blacklist",
                              "bl"
                            )
                          }
                          style={{ marginLeft: "5px" }}
                          disabled={oss_type === "wl" && oss.length > 0}
                        />
                        <Form.Label
                          style={{ marginLeft: "5px" }}
                          column
                          lg={4}
                          id="smallerFontSize"
                        >
                          Blacklist
                        </Form.Label>
                      </div>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              {modalData.system_oss_bl.length > 0 && (
                <Row>
                  <Form.Group
                    as={Row}
                    className="mt-2"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Col lg={3}></Col>
                    <Col lg={4}>
                      <FeatherIcon icon="alert-circle" size={15} />
                      <b> System Blacklisted OS : </b>
                      {(() => {
                        let osbl_str = "";
                        if (modalData?.system_oss_bl?.length > 0) {
                          const ossFiltered = os_list.filter((os: any) =>
                            modalData.system_oss_bl.includes(os.code)
                          );
                          ossFiltered.forEach((el: any) => {
                            osbl_str += `${el.name} (${el.code}), `;
                          });
                          osbl_str = osbl_str.slice(0, -2);
                        }
                        return osbl_str;
                      })()}
                    </Col>
                  </Form.Group>
                </Row>
              )}
              {modalData.browsers_whitelist_blacklist !== "off" && (
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mt-2"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Form.Label column lg={3} id="smallerFontSize">
                        Browsers
                      </Form.Label>
                      <Col lg={4}>
                        <Select
                          isMulti
                          className="react-select react-select-container"
                          classNamePrefix="react-select"
                          options={browsersOptions}
                          defaultValue={commonBrowsers}
                          onChange={(selected) => {
                            formik.setFieldValue(
                              "cjsc_browsers",
                              (selected as any[]).map((opt) => opt.value)
                            );
                          }}
                        />
                      </Col>
                      <Col lg={5}>
                        <div className="checkboxes">
                          <Form.Check
                            type="radio"
                            name="browsers_whitelist_blacklist"
                            checked={
                              formik.values.browsers_whitelist_blacklist ===
                              "wl"
                            }
                            value="wl"
                            onChange={() =>
                              formik.setFieldValue(
                                "browsers_whitelist_blacklist",
                                "wl"
                              )
                            }
                            style={{ marginLeft: "5px" }}
                            disabled={
                              browsers_type === "wl" && browsers.length > 0
                            }
                          />
                          <Form.Label
                            style={{ marginLeft: "5px" }}
                            column
                            lg={4}
                            id="smallerFontSize"
                          >
                            Whitelist
                          </Form.Label>
                          <Form.Check
                            type="radio"
                            name="browsers_whitelist_blacklist"
                            checked={
                              formik.values.browsers_whitelist_blacklist ===
                              "bl"
                            }
                            value="bl"
                            onChange={() =>
                              formik.setFieldValue(
                                "browsers_whitelist_blacklist",
                                "bl"
                              )
                            }
                            style={{ marginLeft: "5px" }}
                            disabled={
                              browsers_type === "wl" && browsers.length > 0
                            }
                          />
                          <Form.Label
                            style={{ marginLeft: "5px" }}
                            column
                            lg={4}
                            id="smallerFontSize"
                          >
                            Blacklist
                          </Form.Label>
                        </div>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              {modalData.system_browsers_bl.length > 0 && (
                <Row>
                  <Form.Group
                    as={Row}
                    className="mt-2"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Col lg={3}></Col>
                    <Col lg={4}>
                      <FeatherIcon icon="alert-circle" size={15} />
                      <b> System Blacklisted Browsers : </b>
                      {(() => {
                        let bbl_str = "";
                        if (modalData?.system_browsers_bl?.length > 0) {
                          const browsersFiltered = browsers_list.filter(
                            (browser: any) =>
                              modalData.system_browsers_bl.includes(
                                browser.code
                              )
                          );
                          browsersFiltered.forEach((el: any) => {
                            bbl_str += `${el.name} (${el.code}), `;
                          });
                          bbl_str = bbl_str.slice(0, -2);
                        }
                        return bbl_str;
                      })()}
                    </Col>
                  </Form.Group>
                </Row>
              )}
            </Card.Body>
          </Card>
          {AuthState.disrupt_opsec_v2 === true && (modalData.v2_ip || modalData.v2_time || modalData.v2_ua) && (
                          <Card className="mt-3">
                              <Card.Body>
                              <h4 className="mb-3 header-title mt-0">DISRUPT AD URL OPSEC</h4>
                                  <Row>
                                      <Col>
          
                                          <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                              <Form.Label column lg={3} id="smallerFontSize">Time (In seconds)</Form.Label>
                                              <Col lg={4}>
                                                  <Form.Control
                                                      type="number"
                                                      className="fsz-875rem"
                                                      name="v2_time"
                                                      value={modalData.v2_time}
                                                      onChange={formik.handleChange}
                                                  ></Form.Control>
                                              </Col>
                                          </Form.Group>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
          
                                          <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                              <Form.Label column lg={3} id="smallerFontSize">IP Address</Form.Label>
                                              <Col lg={4}>
                                                  <Form.Control
                                                      type="ip"
                                                      value={modalData.v2_ip}
                                                      className="fsz-875rem"
                                                      name="v2_ip"
                                                      onChange={formik.handleChange}
                                                  ></Form.Control>
                                              </Col>
                                          </Form.Group>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
          
                                          <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                              <Form.Label column lg={3} id="smallerFontSize">User Agent</Form.Label>
                                              <Col lg={4}>
                                                  <Form.Control
                                                      type="text"
                                                      value={modalData.v2_ua}
                                                      className="fsz-875rem"
                                                      name="v2_ua"
                                                      onChange={formik.handleChange}
                                                  ></Form.Control>
                                              </Col>
                                          </Form.Group>
                                      </Col>
                                  </Row>
                              </Card.Body>
                          </Card> )}

          <Card className="mt-1">
            <Card.Body>
              <Row>
                <Col md={6}>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label column lg={3}>
                      Start Date
                    </Form.Label>
                    <Col lg={9}>
                      <Form.Control
                        type="date"
                        name="startDate"
                        defaultValue={
                          modalData.startDate
                            ? convertUtcToLocal(
                                modalData.startDate,
                                "YYYY-MM-DD HH:mm"
                              ).split(" ")[0]
                            : ""
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label column lg={3}>
                      End Date
                    </Form.Label>
                    <Col lg={9}>
                      <Form.Control
                        type="date"
                        name="endDate"
                        defaultValue={
                          modalData.endDate
                            ? convertUtcToLocal(
                                modalData.endDate,
                                "YYYY-MM-DD HH:mm"
                              ).split(" ")[0]
                            : ""
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label column lg={3}>
                      Start Time
                    </Form.Label>
                    <Col lg={9}>
                      <Form.Control
                        type="time"
                        name="startHour"
                        defaultValue={
                          modalData.startDate
                            ? convertUtcToLocal(
                                modalData.startDate,
                                "YYYY-MM-DD HH:mm"
                              ).split(" ")[1]
                            : ""
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label column lg={3}>
                      End Time
                    </Form.Label>
                    <Col lg={9}>
                      <Form.Control
                        type="time"
                        name="endHour"
                        defaultValue={
                          modalData.endDate
                            ? convertUtcToLocal(
                                modalData.endDate,
                                "YYYY-MM-DD HH:mm"
                              ).split(" ")[1]
                            : ""
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Row style={{ margin: "10px" }}>
            <Col>
              <Button
                style={{ marginLeft: "0", fontWeight: "700" }}
                variant="primary"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                Save Campaign
              </Button>
              <Button
                variant="outline-danger"
                onClick={onClose}
                style={{ marginLeft: "10px" }}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default EditCampaign;
